import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-2xl font-bold" }, "Mapping Fulfillment", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "mr-5 text-xl font-bold"
}, "Mapping option", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_MappingVariant = _resolveComponent("MappingVariant")!
  const _component_MappingOption = _resolveComponent("MappingOption")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    class: "hide-croll"
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: "24",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.state.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.value) = $event)),
                    placeholder: "Select mapping option"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.state.isLoading)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 24,
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  (_ctx.state.value === 'variant')
                    ? (_openBlock(), _createBlock(_component_MappingVariant, {
                        key: 0,
                        product: _ctx.state.product,
                        catalogs: _ctx.state.catalogs
                      }, null, 8, ["product", "catalogs"]))
                    : (_openBlock(), _createBlock(_component_MappingOption, {
                        key: 1,
                        product: _ctx.state.product,
                        catalogs: _ctx.state.catalogs
                      }, null, 8, ["product", "catalogs"]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}